package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

@Serializable
data class GameDTO(
    val id: Long,
    val catalogGameId: Long? = null,
    val name: String,
    val imageUrl: String?,
    val minNumberOfPlayers: Int?,
    val maxNumberOfPlayers: Int?,
    val bggUrl: String?,
    val manualUrl: String?,
    val spotifyUrl: String?,
    val gameDuration: Int?,
    val gameCategoryId: Long? = null,
    val categoryName: String?,
    val gameModeId: Long? = null,
    val modeName: String?,
    val matchesPlayed: Int,
    val status: Int,
    val clanId: Long,
    val bggId: Long? = null,
    val yearPublished: Int? = null,
    val thumbnailUrl: String? = null,
    val bggRank: Int? = null,
    val ratingAverage: Double? = null,
    val complexityAverage: Double? = null
)
